import { render, staticRenderFns } from "./Click2CallSettingsModal.vue?vue&type=template&id=1e9ba7e0&"
import script from "./Click2CallSettingsModal.vue?vue&type=script&lang=js&"
export * from "./Click2CallSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports